import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { ITenant, ITenantFeature } from "@/types/tenant";

export const isFeatureEnabled = (
    tenant: ITenant | null,
    feature: ITenantFeature,
): boolean => {
    if (!tenant) return false;
    return !!tenant.features[feature];
};

export const useTenantFeature = (feature: ITenantFeature): boolean => {
    const tenant = useSelector((state: RootState) => state.tenant.tenant);
    return isFeatureEnabled(tenant, feature);
};
